import { usePaymentTypeActions } from ".."
import { usePaymentTypeBuilders } from "../builders/paymentTypeBuilders"
import { usePaymentTypeLoaders } from "../loaders/paymentTypeLoaders"

export const usePaymentTypeService = () => {
    const { buildPaymentType } = usePaymentTypeBuilders()
    
    const paymentTypeLoaders = usePaymentTypeLoaders()

    const { savePaymentType } = usePaymentTypeActions()

    const archivePaymentType = async (paymentTypeId: string) => {
        const { loadPaymentType } = paymentTypeLoaders()
        const paymentType = await loadPaymentType(paymentTypeId, true)
        const archivedPaymentType = buildPaymentType({
            ...paymentType,
            archived: true
        })
        return savePaymentType(archivedPaymentType)
    }

    return {
        archivePaymentType
    }
}
